export const getCode = (params) => $axios.post("/user/login", params);

export const loginVerification = (params) =>
	$axios.post("/user/loginVerification", params);

export const loginPwd = (params) => $axios.post("/user/loginPwd", params);
